import { useTablePropsInfo } from '@op/hooks/common';
import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { getFeedsComments, getFeedsStatsNew } from '@op/services';
import { useUpdateEffect } from 'ahooks';
import { useEffect, useMemo, useState } from 'react';
import { SortBy } from 'tea-component/lib/table/addons';

export function useRequestComments({
  filter: params,
  sortBy,
  setSortBy,
}: {
  filter?: any;
  sortBy: any;
  setSortBy: any;
}) {
  const [feedsComments, setFeedsComments] = useState<any>({});
  const { loading, wrapperRequestTile } = useCancelRequestHook();
  const [sentimentValue, setSelectSentiment] = useState<number[]>([1, 3, 5]);
  const { pageInfo, changePageInfo } = useTablePropsInfo({
    defaultPageInfo: { page: 1, page_size: 10 },
  });
  const [invalid, setInvalid] = useState<string>();

  // useUpdateEffect：首次挂载不触发（此时 pageInfo 已是默认值，重置会产生新对象引用
  // 导致 filter 重算而重复请求 comments 接口），仅情感筛选变化时重置页码
  useUpdateEffect(() => {
    changePageInfo({ ...pageInfo, page: 1 });
  }, [sentimentValue]);

  const filter = useMemo(() => {
    if (!params?.edition_unified_id) {
      return null;
    }

    let sentiment = sentimentValue;

    if (sentiment.length === 3) {
      sentiment = [];
    } else if (sentiment.length === 0) {
      sentiment = [-99999];
    }

    const filter = {
      ...params,
      ...pageInfo,
      sentiment,
      sort_item: sortBy.by,
      sort_model: sortBy.order,
    };

    if (invalid) {
      filter.is_valid = invalid.split(',').map(Number);
    }

    return filter;
  }, [params, pageInfo]);

  async function requestComments() {
    setFeedsComments({});
    wrapperRequestTile(getFeedsComments, filter, false, 5).then(data => {
      setFeedsComments(data);
    });
  }

  useEffect(() => {
    if (filter) {
      requestComments();
    }
  }, [filter]);

  function changeSort(sortItem: SortBy<any>) {
    setSortBy(sortItem);

    changePageInfo({ ...pageInfo, page: 1 });
  }

  function changeInvalid(invalid: string | undefined) {
    setInvalid(invalid);
    changePageInfo({ ...pageInfo, page: 1 });
  }

  return {
    feedsComments,
    loading,
    sentimentValue,
    setSelectSentiment,
    pageInfo,
    changePageInfo,
    sortBy,
    changeSort,
    changeInvalid,
    invalid,
  };
}

export function useRequestStats({ filter }: { filter?: any }) {
  const [feedsStats, setFeedsStats] = useState<{ [key: string]: number }>({});

  const { loading, wrapperCancelRequest } = useCancelRequestHook();

  function requestState() {
    wrapperCancelRequest(getFeedsStatsNew, filter, false, {
      user_cache_expire: 5,
    }).then(data => {
      setFeedsStats(data);
    });
  }

  useEffect(() => {
    requestState();
  }, [filter]);

  return { feedsStats, loading };
}
